import FJUtil from '../../util/FJUtil.js';
import { setMediaLibraryInfo } from '../slices/FJSliceModals.js';
import FJAppConstant from '../../constants/FJAppConstant.js';

/**
 * 所有和编辑页相关action
 */
const FJActionEditPage = {
    openMediaLibraryAction: function (options) {
        return (dispatch, getState) => {
            if (window.EDIT_PAGE_API) {
                window.EDIT_PAGE_API.openMediaLibrary(options);
            }
        };
    },
    // 添加url资源到媒体库
    addToMediaLibraryAction: function (resource, options = {}) {
        return (dispatch, getState) => {
            if (!resource) return;

            const appType = getState().common.appType;
            const { from = '' } = options;
            FJUtil.eaLog('ai tool add to media click', { position: from, 'ai tool': appType });

            if (window.EDIT_PAGE_API) {
                if (typeof resource === 'string') window.EDIT_PAGE_API.addUrlToMediaLibrary(resource);
                else window.EDIT_PAGE_API.addBlobToMediaLibrary(resource);
            }
        };
    },
    addMultipleMediaToMediaLibraryAction: function (list, options = {}) {
        return (dispatch, getState) => {
            if (list.length === 1) {
                dispatch(FJActionEditPage.addToMediaLibraryAction(list[0], options));
                return;
            }

            const appType = getState().common.appType;
            const { from = '' } = options;
            let count = list.length;
            const addList = [];
            let showError = false,
                showExist = false,
                showSuccess = false;
            const ignoreErrorModal = false;
            const __addCallback = data => {
                const { message, info } = data;
                switch (data.message) {
                    case 'exist':
                        showExist = true;
                        if (appType === FJAppConstant.AI_AUDIO_GENERATOR) {
                            const historyList = getState().common.historyList;
                            const item = historyList.find(item => item.audioUrl === info.url);
                            addList.push({
                                status: message,
                                info: { ...info, url: item.coverUrl, name: item.audioName },
                            });
                        } else {
                            addList.push({ status: message, info });
                        }
                        break;
                    case 'failed':
                        showError = true;
                        if (appType === FJAppConstant.AI_AUDIO_GENERATOR) {
                            const historyList = getState().common.historyList;
                            const item = historyList.find(item => item.audioUrl === info.url);
                            addList.push({
                                status: message,
                                info: { ...info, url: item.coverUrl, name: item.audioName },
                            });
                        } else {
                            addList.push({ status: message, info });
                        }

                        break;
                    case 'success':
                        showSuccess = true;
                        break;
                }
                count--;
                if (count === 0) {
                    if (ignoreErrorModal) {
                        window.EDIT_PAGE_API.showAddMediaMessage(showExist, showError, showSuccess);
                    } else {
                        if (showSuccess) window.EDIT_PAGE_API.showAddMediaMessage(false, false, showSuccess);
                        if (showExist || showError) dispatch(setMediaLibraryInfo({ visible: true, list: addList }));
                    }
                }
            };

            if (window.EDIT_PAGE_API) {
                FJUtil.eaLog('ai tool add to media click', { position: from, 'ai tool': appType });
                list.forEach(resource => {
                    if (typeof resource === 'string')
                        window.EDIT_PAGE_API.addUrlToMediaLibrary(resource, {
                            ignoreMessage: true,
                            callback: __addCallback,
                        });
                    else
                        window.EDIT_PAGE_API.addBlobToMediaLibrary(resource, {
                            ignoreMessage: true,
                            callback: __addCallback,
                        });
                });
            }
        };
    },
    // 应用到编辑页
    applyToEditPageAction: function (resource, options) {
        return (dispatch, getState) => {
            if (!resource) return;
            const appType = getState().common.appType;

            FJUtil.eaLog('ai tool apply to media click', { 'ai tool': appType });
            if (window.EDIT_PAGE_API) {
                if (typeof resource === 'string') window.EDIT_PAGE_API.onApplyUrl(resource, options);
                else window.EDIT_PAGE_API.onApplyBlob(resource, options);
            }
        };
    },
    // 应用AI文字创作视频
    applyTextToVideoAction: function (generateData) {
        return () => {
            if (!generateData) return;
            if (window.EDIT_PAGE_API) {
                window.EDIT_PAGE_API.applyTextToVideoAction(generateData);
            }
        };
    },
};

export default FJActionEditPage;
